import React, { useState } from 'react';
import './search.css';
import SearchIcon from '@material-ui/icons/Search';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import User from '../user-circle.svg';
import ProfileImage from '../ProfileImage/ProfileImage';
const { readCookie } = require('../Functions/Cookies.js');

function Search({
  TblPagination,
  paginationCheck,
  searchStatus,
  setData,
  setLength,
}) {
  const imageUrl = window.localStorage.getItem('imageUrl');
  const image = imageUrl === 'null' ? User : imageUrl;
  const schoolId = window.localStorage.getItem('schoolsId');
  const handleSearch = async (e) => {
    let target = e.target;

    if (target === '') {
      await fetch(
        `${process.env.REACT_APP_ORIGIN}/api/v1/stafss?school=${schoolId}&page=1&limit=10`,
        {
          headers: {
            token: `${readCookie('token')}`,
          },
        }
      )
        .then((res) => res.json())
        .then((data) => {
          setData(data.data.staffs);
        });
      await fetch(
        `${process.env.REACT_APP_ORIGIN}/api/v1/staffs/total?school=${schoolId}`,
        {
          headers: {
            token: `${readCookie('token')}`,
          },
        }
      )
        .then((res) => res.json())
        .then((data) => {
          setLength(data.data.totalStaffs);
        });
    } else {
      fetch(
        `${process.env.REACT_APP_ORIGIN}/api/v1/staffs?school=${schoolId}&name[regex]=${target.value}&name[options]=i`,
        {
          headers: {
            token: `${readCookie('token')}`,
          },
        }
      )
        .then((data) => data.json())
        .then((res) => {
          setData(res.data.staffs);
        });
    }
  };

  return (
    <>
      <div className='searchNav'>
        <div className='searchNav-left'>
          <div className='searchNav-left-heading'>
            <h2>Teacher</h2>
          </div>
          <div className='searchNav-left-heading-pagination'>
            {paginationCheck === 'Yes' ? (
              <TblPagination></TblPagination>
            ) : (
              <></>
            )}
          </div>
        </div>
        {/**Search Right */}
        <div className='searchNav-right'>
          <div className='searchNav-right-searchinput'>
            {searchStatus === 'Yes' ? (
              <>
                {' '}
                <input
                  type='text'
                  placeholder='Search Something'
                  onChange={handleSearch}
                ></input>
                <SearchIcon className='search-icon'></SearchIcon>
              </>
            ) : (
              ''
            )}
          </div>
          <div className='searchNav-right-user'>
            {/* <img src={image} alt='teacher'></img> */}
            <ProfileImage />
          </div>
        </div>
      </div>
    </>
  );
}

export default Search;
